import React from 'react';
import { withImageOptimizer } from 'Utils/Content';
import { SectionTitle } from 'Components/Titles';
import { SmartLink } from 'Components/SmartLink';
import FeatureImage from 'Components/FeatureImage';
import { device } from 'device.js';
import { Markdown } from 'Components/Markdown';
import { useStore } from 'Hooks/useStore';
import './ButtonCTA.css';

const getCtaComponent = (ctaText, url) => {
  if (ctaText) {
    return <SmartLink text={ctaText} linkUrl={url} className="ButtonCTALink" reload />;
  }
  return null;
};

export const ButtonCTA = ({ headline, description, ctaText, url, image, screenName }) => {
  const { screens } = useStore('appConfig');

  const defaultRenderer = {
    p: ({ children }) => <span className="ButtonCTADescription">{children}</span>,
  };

  if (device.mobile) {
    return (
      <div className="ButtonCTA" data-testid="ButtonCTA">
        <div className="ButtonCTABackgroundContainer">
          <h3 className="MobileSectionTitle">{headline}</h3>
          <div className="MobileCTADescriptionContainer">
            Go mobile with Fox Nation. Our official app makes it easy to watch anywhere!
          </div>
        </div>
        {getCtaComponent(ctaText, screenName, screens, url)}
      </div>
    );
  }

  return (
    <div className="ButtonCTA" data-testid="ButtonCTA">
      <SectionTitle text={headline} align="center" />
      {description && (
        <Markdown className="ButtonCTADescriptionContainer" children={description} components={defaultRenderer} />
      )}
      {image && <FeatureImage url={url} src={withImageOptimizer(image)} srcSet="" />}
      {getCtaComponent(ctaText, screenName, screens, url)}
    </div>
  );
};
